import { AxiosInstance } from "axios";

import {
  ExamDataResponseService,
  GenericsOptions,
  MoldeDataResponseService,
  MoldesQuery,
} from "./types";

export default class ExamsMoldesService {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async getMoldesData({
    companyId,
    generics = GenericsOptions.YES,
  }: MoldesQuery): Promise<MoldeDataResponseService> {
    const companyIdUrl = companyId ? `company=${companyId}` : "";
    const genericsUrl = `&generic=${generics}`;

    const url: string = `/moldes/data?${companyIdUrl}${genericsUrl}`;
    return this.axios.get(url);
  }

  public async getMoldes(
    company_id: string,
    type: any[]
  ): Promise<MoldeDataResponseService> {
    const url: string = `moldes/pc-pi`
    return this.axios.get(url, {
      params: {
        company_id,
        type
      }
    });
  };

  public async getExamsData(): Promise<ExamDataResponseService> {
    const url: string = "/exams/data/with-practices";
    return this.axios.get(url);
  }

  public async getExamsWithPracticesDataFilteredByPatientType(patientType: string): Promise<any> {
    const PATIENT_TYPES = {
      COMPANY_CANDIDATE: ["COMPANY_CANDIDATE", "CANDIDATE", "Postulante"],
      COMPANY_EMPLOYEE: ["COMPANY_EMPLOYEE", "EMPLOYEE", "Empleado"],
      PARTICULAR_CLIENT: "PARTICULAR_CLIENT",
    };

    function includesAnyKeyword(value: string, keywords: string[]): boolean {
      const lowercasedValue = value.toLowerCase();
      return keywords.some(keyword => lowercasedValue.includes(keyword.toLowerCase()));
    };
    const returnPatientType = () => {
      let type = ['candidate', 'employee'];
      if (includesAnyKeyword(patientType, PATIENT_TYPES.COMPANY_CANDIDATE)) return type = ['candidate'];
      if (includesAnyKeyword(patientType, PATIENT_TYPES.COMPANY_EMPLOYEE)) return type = ['employee'];
      return type
    }


    const url: string = `/exams/withPracticesPC`;
    const response: any = await this.axios.get(url, {
      params: {
        type: returnPatientType()
      }
    });
    return response;
    // const examsWithPractices = response.filter((exam: any) => exam.enabled === true);
    // let filtered;



    // function doesNotIncludeKeywords(value: any, keywords: string[]): boolean {
    //   if (typeof value !== "string") {
    //     return true; // Si no es una cadena, no incluye las palabras clave
    //   }
    //   const lowercasedValue = value.toLowerCase();
    //   return !keywords.some(keyword => lowercasedValue.includes(keyword.toLowerCase()));
    // };




    // if (includesAnyKeyword(patientType, PATIENT_TYPES.COMPANY_CANDIDATE)) {
    //   const searchPattern = /ingreso|pre-ocupacional| Preocupacional | preocupacional| Pre-Ocupacional/i; // Expresión regular para buscar "ingreso" o "pre-ocupacional" sin importar mayúsculas/minúsculas
    //   const perfilesPsicologicos = ['1012', '1013', '1014']
    //   filtered = examsWithPractices.filter((e: any) =>
    //     searchPattern.test(e?.name) || perfilesPsicologicos.includes(e?.managerId)
    //   );

    //   return filtered;
    // };

    // if (includesAnyKeyword(patientType, PATIENT_TYPES.COMPANY_EMPLOYEE)) {
    //   const excludedKeywords = ["ingreso", "pre-ocupacional", "Preocupacional", "preocupacional", "Pre-Ocupacional"]; // Palabras clave a excluir

    //   filtered = examsWithPractices.filter((e: any) =>
    //     Object.values(e).every((value) => doesNotIncludeKeywords(value, excludedKeywords))
    //   );

    //   return filtered;
    // };

  //  if (patientType === PATIENT_TYPES.PARTICULAR_CLIENT) return examsWithPractices;
  }




}
